import { isNumber } from './number'

/*
/ sorting - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
*/
// export function deepSort(prop, arr, sortProperty, descending = false) {
//   // var sort = function (prop, arr) {
//     prop = prop.split('.');
//     var len = prop.length;

//     arr.sort(function (a, b) {
//         var i = 0;
//         while( i < len ) { a = a[prop[i]]; b = b[prop[i]]; i++; }
//         if (a < b) {
//             return -1;
//         } else if (a > b) {
//             return 1;
//         } else {
//             return 0;
//         }
//     });
//     return arr;
// // };
// }

// this.items = items.sort(sortData('metadata.seller_name'[, [true, false]]));
export const sortData = (sortProperty, descending = false) => {
  // console.log('\nsortData sortProperty',sortProperty)
  // console.log('sortData descending',descending)
  let sortOrder = 1;

  return function (a,b) {
    // console.log('\nsortData a',a)
    // console.log('sortData b',b)
    let one = sortProperty.split('.').reduce((o,i)=>o[i], a);
    let two = sortProperty.split('.').reduce((o,i)=>o[i], b);
    // console.log('one',one)
    // console.log('two',two)
    const oneType = typeof one;
    const twoType = typeof two;

    // strings
    if (oneType === 'string') {
      one = String(one).toLowerCase().trim()
    }
    if (twoType === 'string') {
      two = String(two).toLowerCase().trim()
    }

    

    let result;

    if (!one) {
      // console.log('!one')
      result = descending ? -1 : 1;
    }
    else if (!two) {
      // console.log('!two')
      result = descending ? 1 : -1;
    }
    // else do the comparison
    else {
      // console.log('comparison')
      if(!descending) {
        result = (one < two) ? -1 : (one > two) ? 1 : 0;
        // console.log('ascending')
      }
      else {
        result = (one < two) ? 1 : (one > two) ? -1 : 0;
        // console.log('descending')
      }
    }
    // console.log('result',result)
    return result * sortOrder;
  }
}


// let sorted = ref.sort(simpleSort('name'));
export const simpleSort = (property, caseInsensitive = true) => {
  let sortOrder = 1;
  if(property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a,b) {
    let aProp = caseInsensitive ? a[property].toLowerCase() : a[property]
    let bProp = caseInsensitive ? b[property].toLowerCase() : b[property]
    let result = (aProp < bProp) ? -1 : (aProp > bProp) ? 1 : 0;
    return result * sortOrder;
  }
}

export default {
  sortData,
  simpleSort,
};
